<template>
    <div>
        <el-form :inline="true">
            <el-form-item label="用户ID">
                <el-input v-model="queryParams.userId" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="快照时间">
                <el-date-picker v-model="queryParams.time" type="datetime" value-format="timestamp"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button style="margin-left: 10px" type="primary" @click="getUserBalanceSnapshot">搜 索</el-button>
            </el-form-item>
        </el-form>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="userId" label="用户Id"/>
            <el-table-column prop="coinType" label="币种"/>
            <el-table-column prop="coinAmount" label="可用数量"/>
            <el-table-column prop="coinFroze" label="冻结数量"/>
            <el-table-column prop="amount" label="总数"/>
            <el-table-column label="快照时间">
                <template slot-scope="scope">
                    <span>{{scope.row.snapshotTime | moment}}</span>
                </template>
            </el-table-column>

        </el-table>

    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: "BalanceSnapshot",
        data() {
            return {
                dataList: [],
                queryParams: {
                    userId: '',
                    time: ''
                }
            }
        },
        created() {

        },
        methods: {
            getUserBalanceSnapshot() {
                if (this.queryParams.userId == "") {
                    this.$message.info("请输入查询用户的ID！");
                    return;
                }
                if (this.queryParams.time == null || this.queryParams.time == "") {
                    this.$message.info("请输入查询时间！");
                    return;
                }
                api.getUserBalanceSnapshot(this.queryParams).then(({data}) => {
                    this.dataList = data;
                });
            }
        }
    }
</script>

<style scoped>

</style>
